import { apolloClient } from "@/plugins/vue-apollo";
import { doMutation } from "../../core-module/util/graphqlHelper";

const updateGetTrainingCategoriesCache = ({ trainingCategory }) => {
  try {
    if (trainingCategory) {
      const cacheKey = {
        query: require("../api/query/getTrainingCategories.gql"),
        variables: { pageInput: { skip: 0, limit: 0 } },
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData?.getTrainingCategories) {
        const existingIndex =
          cachedData.getTrainingCategories.trainingCategories.findIndex(
            x => x._id === trainingCategory._id
          );

        if (existingIndex >= 0) {
          cachedData.getTrainingCategories.trainingCategories.splice(
            existingIndex,
            1
          );
        }

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    console.log(
      "deleteTrainingCategory.updateGetTrainingCategoriesCache:exception:",
      e.message
    );
  }
};

export const deleteTrainingCategory = id => {
  const mutation = require("../api/mutation/deleteTrainingCategory.gql");
  const variables = { id: id };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetTrainingCategoriesCache({
        trainingCategory: data.deleteTrainingCategory,
      });

      return { data: data.deleteTrainingCategory };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
